import { useState, useContext, useEffect } from 'react';
import '../classes/styles/style.css';
import ActionBtn from '../components/actionBtn';
import * as WS from '../webServices/cyMyManager';
import * as UT from '../classes/utility'
import Screen from '../components/screen';
import { GlobalContextData, GetGlobalContext } from '../classes/context';
import Spinner from '../components/spinner';
import { DurataPeriodo, SedeEsercenteInit, TipoAbbonamento, TipoDurata, TipoRigaAbb } from '../webServices/cyMyManagerPlusInterface';
import Modal from '../components/modal';
import { IF, deleteAbbonamento } from '../webServices/cyMyManagerPlus';
import { Dropdown, MultiSelect, SelectPanel } from "react-multi-select-component";
import TableAbbonamenti from '../mobile-components/tableAbbonamenti';

export default function Abbonamenti() {
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);
    const [modalShow, setModalShow] = useState(false)
    const [abbonamenti, setAbbonamenti] = useState<WS.Plus.IF.Abbonamento[] | undefined>(undefined);
    const [abbSel, setAbbSel] = useState<WS.Plus.IF.Abbonamento | undefined>(undefined);
    const [servizi, setServ] = useState<WS.Plus.IF.Articolo[] | undefined>(undefined);
    const [sedi, setSedi] = useState<WS.Plus.IF.SedeEsercente[] | undefined>(undefined);
    const [abbChk, setAbbChk] = useState<number[]>([]);
    const [alert, setAlert] = useState<boolean>(false);
    const [filSedeSel, setFilSedeSel] = useState<string | undefined>(undefined)

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // Form Abbonamenti
    const [sedeSel, setSedeSel] = useState<string>("")
    const [nomeAbb, setNomeAbb] = useState<string>("");
    const [tipoServ, setTipoServ] = useState<"SERV" | "SELF">("SERV");
    const [codiceAbb, setCodiceAbb] = useState<string>("");
    const [desAbb, setDesAbb] = useState<string>("");
    const [prezAbb, setPrezAbb] = useState(0);
    const [tipoAbb, setTipoAbb] = useState<number>(0)
    const [durAbb, setDurAbb] = useState<number>(1)
    const [ingAbb, setIngAbb] = useState<number>(0)
    const [venAbb, setVenAbb] = useState<boolean>(false)
    const [restr, setRestr] = useState<number>(0)
    const [numRes, setNumRes] = useState<number>(0)
    const [servSel, setServSel] = useState<WS.Plus.IF.Articolo[]>([]);
    const [alertWrap, setAlertWrap] = useState<string>('alert-wrap');

    const [servMultOpt, setServMultOpt] = useState<{ label: string; value: string }[]>([]);
    const [servMultSel, setServMultSel] = useState<{ label: string; value: string }[]>([]);

    const viewOperOK = () => {
        setModalShow(false)
        setAlertWrap('alert-wrap alert-show');

        setTimeout(() => {
            setAlertWrap('alert-wrap');
        }, 3000)
    }

    const updateAbbonamenti = async (body: WS.Plus.IF.Abbonamento): Promise<WS.Plus.IF.GenericResponse> => {
        body.Codice = tipoServ + '-' + codiceAbb; // nomeAbb.substring(0, 3);
        body.Nome = nomeAbb;
        body.Descrizione = desAbb;
        body.Prezzo = prezAbb;
        body.IdSedeEserc = parseInt(sedeSel);
        body.articoli = [
            ...servMultSel.map(s => ({ ...WS.Plus.IF.ArticoloInit(), Id: parseInt(s.value) }))
        ]
        body.tipoAbb = tipoAbb;
        body.Durata = durAbb;
        body.Quantita = ingAbb;
        body.LimitePeriodo = restr;
        body.QtaPerPeriodo = numRes;
        body.Vendibile = venAbb;

        console.log(body.IdSedeEserc)


        if (isNaN(body.IdSedeEserc) || body.IdSedeEserc == 0)
            return WS.Plus.IF.GenericErrorResponse("Sede non indicata!")

        if (body.Nome == '')
            return WS.Plus.IF.GenericErrorResponse("Nome non indicato!")

        if (body.Descrizione == '')
            return WS.Plus.IF.GenericErrorResponse("Descrizione non indicata!")

        if (isNaN(body.Prezzo) || body.Prezzo <= 0 || (body.Prezzo.toString().split('.').length > 1 && body.Prezzo.toString().split('.')[1].length > 2))
            return WS.Plus.IF.GenericErrorResponse("Prezzo non valido!")

        if (servMultSel.length == 0)
            return WS.Plus.IF.GenericErrorResponse("Indicare almeno un servizio!")

        // body.Codice = body.Nome.substring(0, 3);

        let res = await WS.Plus.updateAbbonamento(WS.UT.TOKEN, body)

        await updateListaAbb()

        if (res.isOk)
            viewOperOK()
        else
            console.log(res.msgErr)

        return res;
    }

    const clearForm = () => {
        setSedeSel(filSedeSel!);
        setNomeAbb("");
        setTipoServ("SERV");
        setCodiceAbb('');
        setPrezAbb(0);
        setDesAbb("");
        setAbbSel(WS.Plus.IF.AbbonamentoInit())
        setTipoAbb(0);
        setDurAbb(1);
        setIngAbb(0);
        setNumRes(0);
        setRestr(0);
        setVenAbb(false);
    }

    const updateListaAbb = async () => {
        let listAbb = await WS.Plus.getListaAbbonamentiFull(WS.UT.TOKEN, "", 0, -1, -1, 0, 0, -1, 0, 0, parseInt(filSedeSel ?? '0') ?? 0);
        if (listAbb.isOk)
            setAbbonamenti(listAbb.list);

        clearForm();
    }

    const deleteAbb = async (idAbbonamento: number) => {
        let res = await WS.Plus.deleteAbbonamento(WS.UT.TOKEN, idAbbonamento)

        await updateListaAbb()

        if (res.isOk)
            viewOperOK()
        else
            window.alert(res.msgErr)

        return res;

    }

    const handleTipoAbb = (tipo: number) => {
        setTipoAbb(tipo)
    }

    const onMultipleDelete = async () => {
        for (let i = 0; i < abbChk.length; i++) {
            await deleteAbbonamento(WS.UT.TOKEN, abbChk[i])
        }

        await updateListaAbb()

        setAbbChk([]);

        viewOperOK();
    }

    const passToModal = (abbonamento: WS.Plus.IF.Abbonamento) => {
        if (abbonamento.tipoAbb == 0)
            return;

        if (abbonamento.Nome.includes("Crediti"))
            return;
        setSedeSel(filSedeSel!)
        setNomeAbb(abbonamento.Nome)
        setDesAbb(abbonamento.Descrizione)
        setPrezAbb(abbonamento.Prezzo)
        setTipoServ(abbonamento.Codice.substring(0, 4) as "SERV" | "SELF")
        setCodiceAbb(abbonamento.Codice.substring(5))
        setTipoAbb(abbonamento.tipoAbb)
        setDurAbb(abbonamento.Durata)
        setIngAbb(abbonamento.Quantita)
        setRestr(abbonamento.LimitePeriodo)
        setNumRes(abbonamento.QtaPerPeriodo)
        setVenAbb(abbonamento.Vendibile)

        setServMultSel([...abbonamento.articoli.map(a => ({ label: a.Descrizioni[0].Descrizione, value: a.Id.toString() }))])

        setAbbSel(abbonamento)
        setModalShow(true);
    }

    const onLoad = async (): Promise<void> => {
        // await updateListaAbb()

        let listSedi = await WS.Plus.getListaSediEsercenti(WS.UT.TOKEN, "", globalContext.vars.esercente?.Id ?? 0, 0, 0, 0, 0);

        if (listSedi.isOk) {
            setSedi(listSedi.list);
            setFilSedeSel(listSedi.list[0].Id.toString())
        }
    };

    // Servizi selezionabili nel form: solo quelli della sede selezionata
    const updateListaServ = async () => {
        let listServ = await WS.Plus.getListaArticoli(WS.UT.TOKEN, "", 0, 0, 0, 0, 0, 0, 0, parseInt(filSedeSel ?? '0'), 0, 0)

        if (listServ.isOk) {
            setServ(listServ.list);
            setServMultOpt(listServ.list.map(serv => ({ label: serv.Descrizioni[0].Descrizione, value: serv.Id.toString() })));
        }
    };

    useEffect(() => {
        if (filSedeSel !== undefined) {
            updateListaAbb()
            updateListaServ()
        }

    }, [filSedeSel])


    const checkAllAbb = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const tuttiId = abbonamenti?.map((abbonamento) => abbonamento.Id) || [];
            setAbbChk(tuttiId);
        } else {
            setAbbChk([]);
        }
    };

    const handleCheck = (id: number) => {
        if (abbChk.includes(id)) {
            setAbbChk(abbChk.filter((selezionatoId) => selezionatoId !== id));
        } else {
            setAbbChk([...abbChk, id]);
        }
    };

    useEffect(() => {
        onLoad();
        // console.log(tipoAbb)
    }, []);


    const modalBody = (): JSX.Element =>
        <>
            <div className='row'>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="tipoAbb">Tipo Servizio</label>
                    <select className='form-select' name="tipoAbb" value={tipoServ} onChange={t => setTipoServ(t.target.value as any)}>
                        <option value="SERV">Servito</option>
                        <option value="SELF">Self-service</option>
                    </select>
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="nomeAbb">Codice</label>
                    <input className="form-control " type="text" placeholder="Inserisci codice Abbonamento" value={codiceAbb} onChange={(n) => setCodiceAbb(n.target.value)} />
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="nomeAbb">Nome</label>
                    <input className="form-control " type="text" placeholder="Inserisci nome Abbonamento" value={nomeAbb} onChange={(n) => setNomeAbb(n.target.value)} />
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="prezzoAbb">Prezzo €</label>
                    <input className="form-control" type="number" placeholder="" value={prezAbb} onChange={(num) => setPrezAbb(parseFloat(num.target.value))} />
                </div>
                <div className='col-12 mb-3'>
                    <label htmlFor="Descrizione">Descrizione</label>
                    <textarea className="form-control" value={desAbb} placeholder='Inserisce descrizione abbonamento' rows={5} onChange={(t) => setDesAbb(t.target.value)}></textarea>
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="tipoAbb">Tipo Abbonamento</label>
                    <select className='form-select' name="tipoAbb" value={tipoAbb} onChange={t => handleTipoAbb(parseInt(t.target.value))}>
                        {Object.keys(TipoAbbonamento)
                            .filter(key => isNaN(Number(key)))
                            .map((key, index) => (
                                <option key={index} value={TipoAbbonamento[key as keyof typeof TipoAbbonamento]}>
                                    {key.substring(1)}
                                </option>
                            ))}
                    </select>
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="tipoAbb">Durata Abbonamento</label>
                    <select className='form-select' value={durAbb} onChange={d => setDurAbb(parseInt(d.target.value))}>
                        {Object.entries(TipoDurata)
                            .filter(([key, value]) => isNaN(Number(key)))
                            .map(([key, value], index) => (
                                <option key={index} value={value}>
                                    {key}
                                </option>
                            ))}
                    </select>
                </div>
                {tipoAbb === 1 ?
                    <>
                        <div className='col-12 mb-3'>
                            <label htmlFor="ingressi">Ingressi</label>
                            <input className='form-control' value={ingAbb} type='number' onChange={i => setIngAbb(parseInt(i.target.value))} />
                        </div>
                        <div className='col-12 col-md-6 mb-3'>
                            <label htmlFor="restrizione">Restrizione Ingressi</label>
                            <select className='form-select' name="" id="" value={restr} onChange={r => { setRestr(parseInt(r.target.value)); setNumRes(0) }}>
                                {Object.keys(DurataPeriodo)
                                    .filter(key => isNaN(Number(key))) // Filtra solo le chiavi non numeriche
                                    .map((key, index) => (
                                        <option key={index} value={DurataPeriodo[key as keyof typeof DurataPeriodo]}>
                                            {key}
                                        </option>
                                    ))}
                            </select>
                        </div>
                        <div className='col-12 col-md-6 mb-3'>
                            <label htmlFor="restIng">Quantità restrizione</label>
                            <input className='form-control' value={numRes} type='number' onChange={i => setNumRes(parseInt(i.target.value))} disabled={restr === 0} />
                        </div>
                    </>

                    :
                    <></>
                }
                <div className='col-12 mb-3'>
                    <label>Seleziona servizi</label>
                    <div >
                        <MultiSelect
                            options={servMultOpt}
                            value={servMultSel}
                            onChange={setServMultSel}
                            labelledBy="Seleziona servizi"
                            overrideStrings={UT.multiSelectLabel}
                        />
                    </div>
                    {/* <table className="table">
                        <tbody>
                            {servizi?.map((servizio, index) =>
                                <tr className='pointer' key={index} >
                                    <td scope="row" style={{ width: '55px' }}>
                                        <input className="form-check-input" type="checkbox" checked={false} onChange={() => window.alert(servizio.Codice)} />
                                    </td>
                                    <td onClick={() => window.alert(servizio.Codice)}>{servizio.Descrizioni[0].Descrizione}</td>
                                </tr>
                            )}
                        </tbody>
                    </table> */}
                </div>
                <div className='col-12 mb-3'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" checked={venAbb} id="flexCheckDefault" onChange={(i) => setVenAbb(i.target.checked)}  />
                            <label className="form-check-label" >
                                Valido per la vendita
                            </label>
                    </div>
                </div>
            </div>
        </>


    return (
        <Screen>
            <div className='container'>
                <div className={alertWrap}>
                    <div className="alert alert-primary" role="alert">Operazione Effettuata!</div>
                </div>
                <div className='row'>
                    <div className='d-flex card flex-column flex-md-row mb-3' >
                        <h2>Abbonamenti</h2>
                        <div className='ms-auto'>
                            <ActionBtn
                                modello='Abbonamenti'
                                add={true}
                                del={true}
                                onDel={onMultipleDelete}
                                modalOnSave={() => updateAbbonamenti(abbSel ?? WS.Plus.IF.AbbonamentoInit())}
                                modalOnClose={() => clearForm()}
                                modalBody={modalBody()}
                                onNew={clearForm}
                                sedi={sedi}
                                sedeSel={filSedeSel}
                                setSedeSel={setFilSedeSel}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 card'>
                        <table className="table">
                            <thead>
                                {isMobile ?
                                    <></>
                                    :
                                    <tr>
                                        <th scope='col'>
                                            <input className="form-check-input" type="checkbox" onChange={checkAllAbb} checked={abbonamenti && abbChk.length === abbonamenti.length} hidden={true} />
                                        </th>
                                        <th scope="col">#</th>
                                        <th scope="col">Nome</th>
                                        <th scope="col">Descrizione</th>
                                        <th scope="col">Prezzo</th>
                                    </tr>
                                }
                            </thead>
                            <tbody>
                                {abbonamenti ?
                                    abbonamenti.map((abbonamento, index) =>
                                        isMobile ?
                                            <TableAbbonamenti abbonamento={abbonamento} passToModal={() => passToModal(abbonamento)} />
                                            :
                                            <tr className={'pointer' + (abbonamento.tipoAbb === 0 || abbonamento.Nome.includes("Crediti") ? ' abb-disabled' : undefined)} key={index}>
                                                <td scope="row" style={{ width: '55px' }}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={abbChk.includes(abbonamento.Id)}
                                                        onChange={() => handleCheck(abbonamento.Id)}
                                                        disabled={abbonamento.tipoAbb === 0 || abbonamento.Nome.includes("Crediti")}
                                                    />
                                                </td>
                                                <td onClick={() => passToModal(abbonamento)}>{abbonamento.Id}</td>
                                                <td onClick={() => passToModal(abbonamento)}>{abbonamento.Nome}</td>
                                                <td onClick={() => passToModal(abbonamento)}>{abbonamento.Descrizione}</td>
                                                <td onClick={() => passToModal(abbonamento)}>{abbonamento.Prezzo.toFixed(2) + ' €'}</td>
                                            </tr>
                                    )
                                    :
                                    undefined
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Modal
                isShow={modalShow}
                onClose={() => setModalShow(false)}
                onDel={async () => {
                    if (abbSel?.Id)
                        await deleteAbb(abbSel?.Id);
                }}
                title=""
                body={
                    modalBody()
                }
                onSave={() => updateAbbonamenti(abbSel ?? WS.Plus.IF.AbbonamentoInit())}
            />
        </Screen>
    );
}
